import { Component, OnInit } from '@angular/core';
import { User } from '../../../../classes/User';
import { ROLES } from '../../../data/roles';
import { GlobalService } from '../../../services/global.service';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {


  contentVisible: boolean = false;
  usersData: any[] = [];
  roles: any = {};

  availableRoles: string[] = [ 'admin' ];
  isAvailable: boolean = true;


  constructor ( 
    private model: ModelService,
    private global: GlobalService,
    private loginService: LoginService ) {
    this.global.setDocumentTitle( 'Users' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
    ROLES.forEach( ( element, index, array ) => { this.roles[element.data] = element.name });
  }

  ngOnInit ( ) {
    this.model.getUsersData( ( usersData ) => {
      this.contentVisible = true;
      try {
        usersData = usersData.json( );
        if ( usersData.users ) this.usersData = usersData.users;
      } catch ( exception ) {
      }
    });

  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/users/users/users.component.ts